module.exports = __webpack_public_path__ + "img/redu.5498b148.png";